module.exports = __webpack_public_path__ + "acde15f5.svg";